const langtrans={
      ndddsj:["您的身份","Your Identity"],
      bar:["报案人","Incident Reporter "],
      tbr:["投保人","Insurer"],
      ffws:["服务商","Service Provider"],
      bxgs:["保险公司"," Insurance Company "],
      hgzzzd:["合作单位","Partner"],
      xss:["星使","Xingshi"],
      mmyggd:["没用过大救星","New User"],
      ndddjy:["您的建议是有关于：","Your suggestion is about"],
      qxzz:["请选择","Please select"],
      qtxxnd:["请填写你的建议","Please write your suggestions"],
      xm:["姓名","Name"],
      qsrndd:["请输入您的姓名","Please type your name"],
      lxjfs:["联系方式","Contact"],
      qlxndd:["请留下您的联系方式，方便我们快速沟通反馈","Please leave your contact details for us to get back to you sooner"],
      jy:["建议","Suggestions"],
      tdsjfk:["提交反馈","Submit"],
      cpgn:["产品功能","Product feature"],
      khffw:["客户服务","Customer service"],
      gzzddd:["规则制度","Rules & regulations"],
      jyffw:["救援服务","Assistance services"],
      xssffw:["星使服务","Xingshi services"],
      jjjgxx:["价格相关","Prices"],
      qjt:["其他","Others"],
      nycgtd:["您已成功提交反馈","You have submitted your feedback"],
      jyjgdl:["救援机构登录成功","Your login Assistance organization is successful"],
      jjgjgd:["监管机构登录成功","en_translated"],
      zzzhzz:["指挥中心登录成功","en_translated"],
      dlsbgy:["登录失败，该用户不属于监管机构","en_translated"],
      dlsbyh:["登录失败，用户名或密码错误","Your login failed for incorrect user name or password"],
      dlsbwz:["登录失败，未知错误","Your login failed for unknown reason"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/assets/languagejs/feedback.vue.trans.js